import React, { FC, useEffect, useState } from 'react';
import { Calendar, DateObject } from 'react-multi-date-picker';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';
import { swedish_sv } from './locale/swedish_sv';
import { getCurrentLocaleFormat } from 'utils/format';
import { LocaleLanguage } from 'models/locale-format';

type MultiDatePickerProps = {
    selectedDates: number[] | Date[];
    disableDaysIndex: number[] | undefined;
    onHandleDates: (dates: number[]) => void;
};

const MultiDatePicker: FC<MultiDatePickerProps> = ({
    selectedDates,
    onHandleDates,
    disableDaysIndex,
}: MultiDatePickerProps) => {
    const [dates, setDates] = useState<number[] | Date[] | null>([new Date()]);
    const isSwedish = getCurrentLocaleFormat().language === LocaleLanguage.SV_SE;

    useEffect(() => {
        if (selectedDates) {
            setDates(selectedDates as number[]);
        }
    }, [selectedDates]);

    const handleDates = (dateObject: DateObject[] | null) => {
        const datesArr = dateObject?.map((dateObj: DateObject) => {
            const dateString = new DateObject(dateObj).format();
            return new Date(dateString).setHours(0, 0, 0, 0);
        });
        setDates(datesArr as number[]);
        onHandleDates(datesArr as number[]);
    };

    return (
        <Calendar
            calendar={gregorian}
            locale={isSwedish ? swedish_sv : gregorian_en}
            value={dates}
            weekStartDayIndex={1}
            multiple
            onChange={handleDates}
            minDate={new Date()}
            format={'YYYY-MM-DD'}
            disableYearPicker
            disableMonthPicker
            mapDays={({ date }) => {
                const isWeekend = (disableDaysIndex || [0, 6]).includes(date.weekDay.index);
                if (isWeekend) {
                    return {
                        disabled: true,
                        style: { color: '#ccc' },
                    };
                }
            }}
        />
    );
};
export default MultiDatePicker;
